<template>
  <div id="manual-payment-record-wrapper">
    <h4>Manually Record Payment:</h4>

    <div class="input-wrapper">
      <Input
        class="input"
        type="text"
        heading="Reference"
        :error="paymentNameError"
        @scs-input="titleInput"
      />
      <Input
        class="input"
        type="number"
        heading="Amount"
        :error="paymentAmountError"
        @scs-input="numberInput"
      />
    </div>
    <div class="button-wrapper">
      <round-button-with-icon icon="x" @click="navigateBackwards" />
      <round-button-with-icon
        icon="circle-checkmark"
        @click="submitManualPayment"
      />
    </div>
  </div>
</template>
<script>
import RoundButtonWithIcon from "../../../RoundButtonWithIcon.vue";
import Input from "../../../../Elements/Input.vue";
// import InputWithTitle from "../../SharedComponentsUI/ElementLibrary/InputWithTitle.vue";

// import RoundIconButton from "../../SharedComponentsUI/RoundIconButton.vue";
export default {
  data() {
    return {
      payment: {
        name: undefined,
        amount: undefined,
      },
      paymentNameError: false,
      paymentAmountError: false,
    };
  },
  computed: {},
  methods: {
    titleInput(val) {
      this.payment.name = val;
    },
    numberInput(val) {
      this.payment.amount = val;
    },
    submitManualPayment() {
      if (!this.payment.name) {
        this.paymentNameError = true;
      } else {
        this.paymentNameError = false;
      }
      if (!this.payment.amount) {
        this.paymentAmountError = true;
      } else {
        this.paymentAmountError = false;
      }
      if (!this.paymentNameError && !this.paymentAmountError) {
        let item = {
          name: this.payment.name,
          amount: this.payment.amount * 100,
        };
        let parameters = {
          variable: "invoice_payments",
          value: item,
          operation: "add",
          api_version: this.$store.state.event.api_version,
          eventKey: {
            userId: this.$store.state.event.userId,
            tenantId: this.$store.state.event.tenantId,
          },
        };
        this.$store.dispatch("editEvent", parameters).then(() => {
          this.$emit("close");
        });
      }
    },
    navigateBackwards() {
      this.$emit("navigate-backwards", "choosePaymentType", "close");
    },
  },
  created() {},
  components: {
    // InputWithTitle,
    // RoundIconButton,
    Input,
    RoundButtonWithIcon,
  },
  emits: ["navigate-backwards"],
  props: [],
};
</script>
<style scoped>
#manual-payment-record-wrapper {
}

.input {
  margin: 0 20px;
}

.input-wrapper {
  display: flex;
  margin: 20px;
}

.button-wrapper {
  width: 100px;
  display: flex;
  justify-content: space-between;
}
</style>
